export default __webpack_public_path__ + "static/media/Burger.4819bc97.png";